import React from 'react';
import { useSelector } from 'react-redux';
import { Routes, Route, Navigate } from 'react-router-dom';
import { selectors as authSelectors } from 'store/auth';
import DashboardRoutes from './DashboardRoutes';

const ProtectedRoutes: React.FC = () => {
  const isAuthenticated = useSelector(authSelectors.selectIsAuthenticated);
  const authenticating = useSelector(authSelectors.selectAuthenticating);
  const admin = useSelector(authSelectors.selectAdmin);

  // IF NOT AUTHENTICATING AND IS NOT AUTHENTICATED - REROUTE TO SIGNIN (SignInView)
  if (admin && admin.resetPasswordRequired) return <Navigate to="/resetpassword" />;
  if (!authenticating && !isAuthenticated) return <Navigate to="/" />;

  return (
    <Routes>
      <Route path="/*" element={<DashboardRoutes />} />
    </Routes>
  );
};

export default ProtectedRoutes;
